import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "checkbox-wrap" }
const _hoisted_2 = ["textContent"]

import { ref, onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  value: { type: Boolean, required: true },
  label: { type: String, required: true },
},
  emits: ["update:value", "change"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:value', value: boolean): void;
  (e: 'change'): void;
}), expose: any, slots: any, attrs: any }) {

const Props = __props

const InternalValue = ref<boolean>(false);




onMounted(() => {
  InternalValue.value = Props.value;
});

const OnClick = () => {
  InternalValue.value = !InternalValue.value;
  emit('update:value', InternalValue.value);
  emit('change');
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["checkbox-box", { active: InternalValue.value }]),
      onClick: OnClick
    }, [
      (InternalValue.value)
        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
            key: 0,
            icon: ['far', 'square-check']
          }))
        : (_openBlock(), _createBlock(_component_font_awesome_icon, {
            key: 1,
            icon: ['far', 'square']
          }))
    ], 2),
    _createElementVNode("div", {
      class: "checkbox-label",
      textContent: _toDisplayString(__props.label)
    }, null, 8, _hoisted_2)
  ]))
}
}

})